module.exports = __webpack_public_path__ + "static/media/about-header.2565820a.jpg";